import Big from 'big.js';
import { Typography } from '@mui/material';
import { formatAmount } from '@/utils/amount';

export type CurrencyAmount = {
  currency: string;
  turnover: string | number;
  total_earned?: string | number;
  average_check: string | number;
  successful_transactions: number;
  usdt_rate: string | number | null;
};

export default function CurrencyAmounts({ amounts, field = 'turnover', currency = '' }: {
  amounts?: CurrencyAmount[];
  field?: 'turnover' | 'average_check' | 'total_earned';
  currency?: string;
}) {
  if (!amounts) return <Typography color="text.secondary">Нет данных о валюте</Typography>;
  let converted: Big | null = new Big(0);
  let count = 0;
  for (const item of amounts) {
    count += item.successful_transactions;
    try {
      const rate = item.currency === 'USDT' ? new Big(1) : new Big(item.usdt_rate ?? 0);
      if (rate.lte(0)) converted = null;
      if (converted !== null) converted = converted.plus(new Big(
        field === 'total_earned' ? item.total_earned ?? 0 : item.turnover,
      ).div(rate));
    } catch { converted = null; }
  }
  if (converted && field === 'average_check' && count) converted = converted.div(count);
  return <>
    {amounts.length ? amounts.map((item) => <Typography key={item.currency} fontWeight={600}>
      {formatAmount(item[field] ?? 0)} {item.currency}
    </Typography>) : <Typography fontWeight={600}>0,00 {currency}</Typography>}
    <Typography variant="body2" color="text.secondary">
      {converted !== null ? `≈ ${formatAmount(converted)} USDT` : 'USDT: курс недоступен'}
    </Typography>
  </>;
}
